/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FacebookShareButton, TwitterShareButton } from 'react-share';

import styles from '../../../styles/partials/social-buttons.scss';

const propTypes = {
    url: PropTypes.string,
};

const defaultProps = {
    url: '#',
};

const SocialButtons = ({ url }) => {
    const fullUrl = `${window.location.protocol}//${window.location.hostname}${url}`;
    return (
        <div className={styles.container}>
            <ul>
                <li className={styles.item}>
                    <FacebookShareButton url={fullUrl}>
                        <span className={styles.circle}>
                            <span
                                className={classNames({
                                    [styles.icon]: true,
                                    [styles.facebook]: true,
                                })}
                            />
                        </span>
                    </FacebookShareButton>
                </li>
                <li className={styles.item}>
                    <TwitterShareButton url={fullUrl}>
                        <span className={styles.circle}>
                            <span
                                className={classNames({
                                    [styles.icon]: true,
                                    [styles.twitter]: true,
                                })}
                            />
                        </span>
                    </TwitterShareButton>
                </li>
            </ul>
        </div>
    );
};

SocialButtons.propTypes = propTypes;
SocialButtons.defaultProps = defaultProps;

export default SocialButtons;



// WEBPACK FOOTER //
// ./js/components/partials/SocialButtons.jsx